// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAhrjD5QOtwj7-DfVDZ6JV5ZCoJRCHAKe4',
    projectId: 'gcp-ccet-dev',
    appId: '1:927752194825:web:414fb08d84c3d3b44061d8',
  },
  azureConf: {
    clientId: '112d958d-cb60-451c-a4b9-ef9ec39db45c',
    cloudInstance: 'https://login.microsoftonline.com',
    tenantInfo: 'e7520e4d-d5a0-488d-9e9f-949faae7dce8',
  },
  apiBasePath: '/services',
  catalogsPath: `/catalogs`,
  adminPath: `/admin`,
  systemPath: `/system`,
  casesPath: `/cases`,
  notificationsPath: `/notifications`,
  broadcastPath: `/broadcast`,
  messagingPath: `/messaging`,
  userPreferencesPath: `/userSettings`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
